function UserWishlist() {

    //singleton
    if (typeof UserWishlist.instance === "object") {
        return UserWishlist.instance;
    }

    var self = this;

    //данные корзины
    self.items = new Map();

    //адрес корзины
    //заполнять эту штуку надо в шаблоне view
    self.orderActionsUri = "/order/ajax_wishlist/";
    //макс уникальных позиций
    self.maxItemsCount = 500;

    //уникальные поля для товара
    var itemPrimaryFields = ["id"];
        // //второстепенные поля
        // itemOptionalFields = ["price"];

    // тестирование элемента
    function validateItem(item) {
        //поиск уникальных полей, как правило это id
        for (var i = 0, max = itemPrimaryFields; i < max; i++) {
            if (!item.hasOwnProperty(itemPrimaryFields[i])) {
                return false;
            }
        }

        item.id = parseInt(item.id, 10);

        if (!(item.id)) {
            return false;
        }

        return item;
    }

    function saveWishlist(actionType, data, callback) {
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: self.orderActionsUri + actionType + "/",
            data: {
                data: data
            },
            success: function (items) {
                items.forEach(function (item) {
                    self.items.set(self.getId(item), item);
                });

                if (typeof callback === "function") {
                    callback();
                }
            }
        });
    }

    self.getItemById = function (id) {
        return self.items.get(self.getId({
            id: id
        }));
    };

    self.getId = function (item) {
        var id = '';
        for (var fieldIndex = 0, maxFields = itemPrimaryFields.length; fieldIndex < maxFields; fieldIndex++) {
            id += item[itemPrimaryFields[fieldIndex]];
        }
        return id;
    };


    //загрузка избранного
    self.init = function () {
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: self.orderActionsUri,
            success: function (wishlistData) {
                self.items.clear();
                if (wishlistData) {
                    for (var i = 0, max = wishlistData.length; i < max; i++) {
                        var validItem = validateItem(wishlistData[i]);

                        if (validItem) {
                            self.items.set(self.getId(validItem), Object.assign({}, validItem));
                        }
                    }

                    if (typeof self.onInitCallback === 'function') {
                        self.onInitCallback();
                    }
                }
            }
        });
    };

    self.onInitCallback = null;

    /**
     * Добавление товара в избранное
     *
     * @param {Object} newItem новый объект данных
     * @param {boolean} isSet режим добавления, если не указан - добавление, иначе - выставление нового значения
     * @param {function} callback
     */
    self.putItem = function (newItem, isSet, callback) {
        newItem = validateItem(newItem);

        if (newItem) {
            var currentItem = self.items.get(self.getId(newItem));
            if (isSet && currentItem) {
                saveWishlist("update", currentItem, callback);
            } else {
                if (currentItem) {
                    saveWishlist("update", currentItem, callback);
                } else {
                    if (self.items.length < self.maxItemsCount) {
                        self.items.set(self.getId(newItem), newItem);
                    }
                    saveWishlist("add", newItem, callback);
                }
            }
        }

    };

    //добавление нескольких товаров
    self.putItems = function (items, callback) {
        var newItems = [];

        for (var i = 0, max = items.length; i < max; i++) {
            var newItem = validateItem(items[i]),
                id = self.getId(newItem),
                currentItem = self.items.get(id);

            if (currentItem) {
                newItems.push(currentItem);
            } else {
                if (self.items.length < self.maxItemsCount) {
                    self.items.set(id, Object.assign({}, newItem));
                    newItems.push(newItem);
                }
            }
        }

        saveWishlist("update_many", newItems, callback);
    };

    //удаление товара
    self.removeItem = function (item, callback) {
        var id = self.getId(item);
        if (self.items.has(id)) {
            self.items.delete(id);

            saveWishlist("remove", item, callback);
        }
    };

    self.removeAll = function (callback) {
        saveWishlist("clear", null, callback);
    };

    self.expected = {
        items: []
    };

    UserWishlist.instance = self;
    return self;
}

var Wishlist = new UserWishlist();
